<div class="custom-field" [id]="field?.fieldColumn">
  <!-- <mat-label *ngIf="![null, undefined, ''].includes(field?.fieldCaption) && field?.additionalMetaData?.showLabel">{{field?.fieldCaption}}
    <span *ngIf="field?.isRequired">*</span>
  </mat-label> -->
  <div fxLayout="row" fxLayoutAlign="start start">
    <mat-form-field [floatLabel]="field?.additionalMetaData?.fieldConfig?.floatLabel"
      [appearance]="field?.additionalMetaData?.fieldConfig?.appearance">
      <mat-label *ngIf="![null, undefined, ''].includes(field?.fieldCaption) && field?.additionalMetaData?.showLabel">
        {{field?.fieldCaption}}
      </mat-label>
      <input matInput [matDatepicker]="datepick" readonly (click)="datePick(datepick, field, control)"
        (focus)="datePick(datepick, field, control)" class="datePick"
        [matTooltip]="(control.disabled) ? '' : field.fieldHelpText" [min]="field?.additionalMetaData?.minDate || ''"
        [max]="field?.additionalMetaData?.maxDate || ''" [formControl]="control" [placeholder]="field.fieldPlaceholder"
        [required]="field.isRequired">
      <button mat-icon-button type="button"
        *ngIf="control.status != 'DISABLED' && !([null, undefined, ''].includes(control.value))"
        (click)="controlFunctions.resetValue(control)" matSuffix>
        <mat-icon>close</mat-icon>
      </button>
      <mat-datepicker-toggle *ngIf="([null, undefined, ''].includes(control.value))" matSuffix [for]="datepick">
      </mat-datepicker-toggle>
      <mat-datepicker #datepick (opened)="datePick(datepick, field, control)" (closed)="datePick(null, field, control)"
        [startView]="field?.additionalMetaData?.startView || 'month'"
        [startAt]="field?.additionalMetaData?.startAt || '0'" [touchUi]="field?.additionalMetaData?.touchUi || 'false'"
        [dateClass]="dateClass" (yearSelected)="yearHandler($event)" (monthSelected)="monthHandler($event, datepick)">
      </mat-datepicker>
      <mat-hint *ngIf="(control.untouched || control.valid) && ![null, undefined, ''].includes(field.fieldHelpText)">
        {{field.fieldHelpText}}</mat-hint>
      <mat-error *ngIf="control.errors && control.touched" [innerHtml]="controlFunctions.validationMsg(control, field)">
      </mat-error>
    </mat-form-field>

    <ng-container *ngIf="field?.helpLine?.length">
      <app-help-line [helpLineData]="field.helpLine" fxLayout="row" fxLayoutAlign="start start"
        (helpLineEmit)="helpLineData($event)"></app-help-line>
    </ng-container>
  </div>

</div>